<template>
  <div>
    <div class="subtitle-1 font-weight-bold mb-2">Activity</div>
    <div v-if="!rows.length" class="grey--text text--darken-1">No activity yet.</div>
    <v-simple-table v-else dense>
      <thead>
        <tr>
          <th>Time (SYD . local)</th>
          <th>Who</th>
          <th>What</th>
          <th>Result</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, i) in rows" :key="`activity-${i}`">
          <td>{{ row.timeText }}</td>
          <td>{{ row.who }}</td>
          <td>{{ row.what }}</td>
          <td>{{ row.result }}</td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
import { activityRows } from "@/utils/cvcMigrationPage";

// Who did what, newest first, from the migration record.
export default {
  name: "CvcMigrationActivity",
  props: {
    record: { type: Object, default: null },
    poiState: { type: String, default: "" },
    now: { type: Date, required: true },
    // The statics ledger of the record: its commit and restore runs are rows too.
    statics: { type: Array, default: () => [] },
  },
  computed: {
    rows () {
      return activityRows(this.record, this.poiState, this.now, this.statics);
    },
  },
};
</script>
